import { render, staticRenderFns } from "./UserEditBankAccountDetails.vue?vue&type=template&id=ef575a38&"
import script from "./UserEditBankAccountDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditBankAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditBankAccountDetails.vue?vue&type=style&index=0&id=ef575a38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports